import React, { useEffect } from 'react';
import LucideIcon from '../LucideIcon';

interface XPToastProps {
  points: number;
  onDone?: () => void;
  /**
   * Play the toast animation, which ends at opacity 0. Pass false where the
   * pill is a permanent part of the layout — a summary screen the learner sits
   * on — or the reward silently disappears and leaves a hole where it was.
   */
  animate?: boolean;
}

// Foundation.dc.html's XP toast pill -- "flat gold, no gradient." Plays
// once (Motion.dc.html's toastCycle: slides up, holds, fades) and calls
// onDone so the caller can unmount it; positioning is the caller's call,
// this is just the pill itself.
const XPToast: React.FC<XPToastProps> = ({ points, onDone, animate = true }) => {
  useEffect(() => {
    if (!onDone || !animate) return;
    const timer = setTimeout(onDone, 2600);
    return () => clearTimeout(timer);
  }, [onDone, animate]);

  return (
    <div
      className={animate ? 'ws-toast-cycle' : undefined}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: '10px 18px', borderRadius: 999,
        background: 'var(--gold)', color: 'var(--ink)',
        boxShadow: '0 8px 24px oklch(0.8 0.15 85 / 0.35)',
      }}
    >
      <LucideIcon name="Zap" size={16} />
      <span className="ws-display" style={{ fontSize: 14.5, fontWeight: 700 }}>+{points} XP</span>
    </div>
  );
};

export default XPToast;
